const state = () => ({
  addressText: null,
  addressGoogle: {}
});

const getters = {
  addressText(state) {
    return state.addressText;
  },
  addressGoogle(state) {
    return state.addressGoogle;
  }
};

const mutations = {
  updateAddressText(state, payload) {
    state.addressText = payload;
  },
  updateAddressGoogle(state, payload) {
    state.addressGoogle = payload;
  }
};

export const addressGoogle = {
  state,
  getters,
  mutations,
  namespaced: true
};
